export default ({ user }) => user.permissions.can_mark_blog_articles_as_read;
